<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="green" right :timeout="2000">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex xs12>
        <v-layout wrap>
          <v-flex xs6 md6 py-8 text-left>
            <span class="kumbhBold large">Job Application for {{ applc.jobTitle ? applc.jobTitle.name : 'General Career' }}</span>
          </v-flex>
          <v-flex xs6 md6 py-8 text-right pr-3>
            <!-- <v-btn dense small dark color="#001a00" depressed :ripple="false" >
             {{applc.candidateStatus}}
            </v-btn> -->

            <v-card flat>
              <v-layout wrap>
                <v-flex xs12 class="kumbhRegular">
                  <span>Candidate Status :</span>
                  <span class="kumbhBold" style="color: #001a00">
                    {{ applc.candidateStatus }}
                  </span>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs8 v-if="applc" pt-6>
            <v-layout wrap justify-start text-left class="kumbhRegular">
              <!-- 1. Job Info -->
              <v-flex xs12 py-2 class="mt-2 mb-1">
                <div class="kumbhBold" style="font-size:18px; color:#005f32; border-bottom: 2px solid #005f32; padding-bottom: 5px; display: inline-block;">Job Information</div>
              </v-flex>
              <v-flex xs12 sm4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Job Title</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;" v-if="applc.jobTitle">{{ applc.jobTitle.name }}</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #888;" v-else>General Career Application</div>
              </v-flex>
              <v-flex xs12 sm4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Job Category</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;" v-if="applc.jobCategory">{{ applc.jobCategory.name }}</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #888;" v-else>N/A</div>
              </v-flex>
              <v-flex xs12 sm4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Location</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;" v-if="applc.jobTitle">{{ applc.jobTitle.location }}</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #888;" v-else>N/A</div>
              </v-flex>
              <v-flex xs12 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Job Description</div>
                <div class="kumbhRegular mt-1" style="font-size: 14px; color: #444; background: #f9f9f9; padding: 10px; border-radius: 4px;" v-if="applc.jobTitle" v-html="applc.jobTitle.content"></div>
                <div class="kumbhRegular mt-1" style="font-size: 14px; color: #888; background: #f9f9f9; padding: 10px; border-radius: 4px;" v-else>General application (No specific role).</div>
              </v-flex>
              
              <!-- 2. Personal & Contact Info -->
              <v-flex xs12 py-2 class="mt-4 mb-1">
                <div class="kumbhBold" style="font-size:18px; color:#005f32; border-bottom: 2px solid #005f32; padding-bottom: 5px; display: inline-block;">Personal & Contact Details</div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Applicant Name</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.name }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Date of Birth</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.dob ? DateFormatted(applc.dob) : 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Email Address</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.email }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Mobile Number</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.mobile || 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Current Location</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">
                  <span v-if="applc.currentLocationCity || applc.currentLocationState">
                    {{ applc.currentLocationCity || '' }}<span v-if="applc.currentLocationCity && applc.currentLocationState">, </span>{{ applc.currentLocationState || '' }}
                  </span>
                  <span v-else style="color:#888">N/A</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Permanent Location</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">
                  <span v-if="applc.permanentLocationCity || applc.permanentLocationState">
                    {{ applc.permanentLocationCity || '' }}<span v-if="applc.permanentLocationCity && applc.permanentLocationState">, </span>{{ applc.permanentLocationState || '' }}
                  </span>
                  <span v-else style="color:#888">N/A</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Willing to Relocate?</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">
                  <span v-if="applc.willingToRelocate === true">Yes</span>
                  <span v-else-if="applc.willingToRelocate === false">No</span>
                  <span v-else style="color:#888">N/A</span>
                </div>
              </v-flex>
              <v-flex xs12 sm12 md8 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Preferred Locations</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">
                  <span v-if="applc.preferredLocations && applc.preferredLocations.length > 0">
                    <span v-for="(loc, i) in applc.preferredLocations" :key="i">
                      {{ loc.city }}, {{ loc.state }}<span v-if="i < applc.preferredLocations.length - 1"> | </span>
                    </span>
                  </span>
                  <span v-else style="color:#888">N/A</span>
                </div>
              </v-flex>
              
              <!-- 3. Education & Skills -->
              <v-flex xs12 py-2 class="mt-4 mb-1">
                <div class="kumbhBold" style="font-size:18px; color:#005f32; border-bottom: 2px solid #005f32; padding-bottom: 5px; display: inline-block;">Education & Skills</div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Graduate</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">
                  <span v-if="applc.graduate">Yes - {{ applc.graduateSubject || 'N/A' }} ({{ applc.graduateYear || 'N/A' }})</span>
                  <span v-else-if="applc.graduate === false">No</span>
                  <span v-else style="color:#888">N/A</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Post Graduate</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">
                  <span v-if="applc.postGraduate">Yes - {{ applc.postGraduateSubject || 'N/A' }} ({{ applc.postGraduateYear || 'N/A' }})</span>
                  <span v-else-if="applc.postGraduate === false">No</span>
                  <span v-else style="color:#888">N/A</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Other Qualifications</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">
                  <span v-if="applc.others">Yes - {{ applc.othersSubject || 'N/A' }} ({{ applc.othersYear || 'N/A' }})</span>
                  <span v-else-if="applc.others === false">No</span>
                  <span v-else style="color:#888">N/A</span>
                </div>
              </v-flex>
              <v-flex xs12 sm12 md6 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Additional Qualifications</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.additionalQualifications || 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm12 md6 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px;">Key Professional Skills</div>
                <div>
                  <v-chip v-for="(skill, i) in applc.keyProfessionalSkills" :key="i" small class="mr-2 mb-2" outlined color="#005f32">{{ skill }}</v-chip>
                  <span class="kumbhSemibold" style="font-size: 15px; color: #888;" v-if="!applc.keyProfessionalSkills || applc.keyProfessionalSkills.length === 0">N/A</span>
                </div>
              </v-flex>

              <!-- 4. Professional Experience -->
              <v-flex xs12 py-2 class="mt-4 mb-1">
                <div class="kumbhBold" style="font-size:18px; color:#005f32; border-bottom: 2px solid #005f32; padding-bottom: 5px; display: inline-block;">Professional Experience</div>
              </v-flex>
              <v-flex xs12 sm6 md3 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Total Experience</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.totalYearsOfExperience || 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md3 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Current Position</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.currentPositionTitle || 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md3 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Current Employer</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.currentEmployerName || 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md3 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Notice Period</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.noticePeriod || 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md3 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Current CTC</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.currentCTC || 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md3 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Expected CTC</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.expectedCTC || 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm12 md6 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 4px;">Species Experience</div>
                <div>
                  <v-chip v-for="(spec, i) in applc.experienceWithSpecies" :key="i" small class="mr-2 mb-2" outlined color="#005f32">{{ spec }}</v-chip>
                  <span class="kumbhSemibold" style="font-size: 15px; color: #888;" v-if="!applc.experienceWithSpecies || applc.experienceWithSpecies.length === 0">N/A</span>
                </div>
              </v-flex>
              <v-flex xs12 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Key Responsibilities</div>
                <div class="kumbhRegular mt-1" style="font-size: 14px; color: #444; background: #f9f9f9; padding: 10px; border-radius: 4px;">{{ applc.keyResponsibilities || 'N/A' }}</div>
              </v-flex>

              <!-- 5. General Info -->
              <v-flex xs12 py-2 class="mt-4 mb-1">
                <div class="kumbhBold" style="font-size:18px; color:#005f32; border-bottom: 2px solid #005f32; padding-bottom: 5px; display: inline-block;">General Form Details</div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Date of Apply</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ DateFormatted(applc.createddate) }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">How Did You Hear</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.howDidYouHear || 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Reference Name</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.referenceName || 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Legally Eligible</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">
                  <span v-if="applc.legallyEligible === true">Yes</span>
                  <span v-else-if="applc.legallyEligible === false">No</span>
                  <span v-else style="color:#888">N/A</span>
                </div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Area of Interest</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">{{ applc.areaOfInterest || 'N/A' }}</div>
              </v-flex>
              <v-flex xs12 sm6 md4 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Division / Project</div>
                <div class="kumbhSemibold" style="font-size: 15px; color: #222;">
                  <span v-if="applc.divisionList || applc.projectList">
                    {{ applc.divisionList || '' }} {{ applc.projectList || '' }}
                  </span>
                  <span v-else style="color:#888">N/A</span>
                </div>
              </v-flex>
              <v-flex xs12 py-2 pr-3>
                <div style="font-size: 12px; color: #777; text-transform: uppercase; letter-spacing: 0.5px;">Views on Conservation</div>
                <div class="kumbhRegular mt-1" style="font-size: 14px; color: #444; background: #f9f9f9; padding: 10px; border-radius: 4px;">{{ applc.viewOnConservation || 'N/A' }}</div>
              </v-flex>

            </v-layout>
          </v-flex>
          <v-flex xs1>
            <v-divider vertical></v-divider>
          </v-flex>
          <v-flex xs3 v-if="applc">
            <div style="max-width: 240px; margin: 0 auto; text-align: center;">
              <v-layout wrap justify-center v-if="applc.coverLetter">
                <v-flex xs12>
                <span class="kumbhBold" style="font-size: 20px">
                  Cover Letter
                </span>
              </v-flex>
              <v-flex xs12 py-3 v-if="applc.coverLetter">
                <span
                  v-if="
                    applc.coverLetter.split('.').pop() == 'pdf' ||
                    applc.coverLetter.split('.').pop() == 'PDF' ||
                    applc.coverLetter.split('.').pop() == 'xlsx' ||
                    applc.resume.split('.').pop() == 'doc' ||
                    applc.resume.split('.').pop() == 'docx'
                  "
                >
                  <a :href="mediaURL + applc.coverLetter" target="_blank">
                    <v-btn dark color="blue" small> View </v-btn></a
                  ></span
                >
                <span v-else>
                  <v-btn
                    @click="(doc = applc.coverLetter), (dialog = true)"
                    dark
                    color="blue"
                    small
                  >
                    View
                  </v-btn>
                </span>
                <!-- <v-btn dark color="blue" small>
                  <span>View</span>
                </v-btn> -->
              </v-flex>
            </v-layout>

            <v-layout wrap justify-center v-if="applc.resume" pt-6>
              <v-flex xs12>
                <span class="kumbhBold" style="font-size: 20px"> CV </span>
              </v-flex>
              <v-flex xs12 py-3 v-if="applc.resume">
                <span
                  v-if="
                    applc.resume.split('.').pop() == 'pdf' ||
                    applc.resume.split('.').pop() == 'PDF' ||
                    applc.resume.split('.').pop() == 'xlsx' ||
                    applc.resume.split('.').pop() == 'doc' ||
                    applc.resume.split('.').pop() == 'docx'
                  "
                >
                  <a :href="mediaURL + applc.resume" target="_blank">
                    <v-btn dark color="blue" small> View </v-btn></a
                  ></span
                >
                <span v-else>
                  <v-btn
                    @click="(doc = applc.resume), (dialog = true)"
                    dark
                    color="blue"
                    small
                  >
                    View
                  </v-btn>
                </span>
              </v-flex>
            </v-layout>
            <v-dialog
            persistent
            v-model="addEmployeeDialog"
            max-width="600px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="applc.candidateStatus != 'Selected'"
                small
                style="font-family: kumbhSemibold"
                class="mr-2"
                dense
                dark
                block
                v-on="on"
                v-bind="attrs"
                color="green"
              >
                <span v-if="applc.candidateStatus == 'Pending'">
                  Interested
                </span>
                <span v-if="applc.candidateStatus == 'Interested'">
                  Shortlist
                </span>
                <span v-if="applc.candidateStatus == 'Shortlisted'">
                  Select Candidate
                </span>
              </v-btn>
            </template>
          
            <v-card>
              <v-card-title>
                <template v-if="applc.candidateStatus == 'Shortlisted'">
                  Are you sure you want to select this candidate?
                </template>
                <template v-else-if="applc.candidateStatus == 'Interested'">
                  Do you want to shortlist this candidate?
                </template>
                <template v-else-if="applc.candidateStatus == 'Pending'">
                  Do you want to move this candidate to the interested list?
                </template>
              </v-card-title>
          
              <!-- Input Fields for Shortlisted Candidate -->
              <v-card-text v-if="applc.candidateStatus == 'Shortlisted'">
                <v-text-field
                  label="Name" outlined dense
                  v-model="applc.name" readonly
                  required
                ></v-text-field>
                <v-text-field
                  label="Email" outlined dense
                  v-model="applc.email" readonly
                  required
                ></v-text-field>
                <v-text-field
                  label="Phone Number" outlined dense
                  v-model="applc.mobile" 
                  required
                ></v-text-field>
                <!-- <v-text-field
                  label="Position ID"
                  v-model="positionId" outlined dense
                  required
                ></v-text-field> -->
                <v-select
                v-model="positionid"
                :items="positionList"
                item-text="name"
                multiple
                item-value="_id"
                outlined
                dense
                label="Choose Position(s)"
              >
              </v-select>
                <v-text-field
                  label="Employee ID" outlined dense
                  v-model="employeeId"
                  required
                ></v-text-field>
                <v-text-field
                  label="Date of Joining"
                  v-model="dateOfJoining" outlined dense
                  type="date"
                  required
                ></v-text-field>
              </v-card-text>
          
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="addEmployeeDialog = false">
                  No
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="addAsEmployee"
                  v-if="applc.candidateStatus == 'Shortlisted'"
                >
                  Yes
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="ChangeEmpStatus('Shortlisted')"
                  v-if="applc.candidateStatus == 'Interested'"
                >
                  Yes
                </v-btn>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="ChangeEmpStatus('Interested')"
                  v-if="applc.candidateStatus == 'Pending'"
                >
                  Yes
                </v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
            <!-- <v-dialog
              persistent
              v-model="addEmployeeDialog"
              max-width="600px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="applc.candidateStatus != 'Selected'"
                  small
                  style="font-family: kumbhSemibold"
                  class="mr-2"
                  dense
                  dark
                  block
                  v-on="on"
                  v-bind="attrs"
                  color="green"
                >
                  <span v-if="applc.candidateStatus == 'Pending'">
                    Interested
                  </span>
                  <span v-if="applc.candidateStatus == 'Interested'">
                    Shortlist
                  </span>
                  <span v-if="applc.candidateStatus == 'Shortlisted'">
                    Select Candidate
                  </span>
                </v-btn>
             
               
               
          
              </template>
              <v-card>
                <v-card-title>
                  <template v-if="applc.candidateStatus == 'Shortlisted'">
                    Are you sure you want select this candidate?
                  </template>
                  <template v-if="applc.candidateStatus == 'Interested'">
                    Do you want to shortlist this candidate?
                  </template>
                  <template v-if="applc.candidateStatus == 'Pending'">
                    Do you want to move this candidate to interested list?
                  </template>
                </v-card-title>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="addEmployeeDialog = false"
                    >No</v-btn
                  >
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="addAsEmployee"
                    v-if="applc.candidateStatus == 'Shortlisted'"
                    >Yes</v-btn
                  >

                  <v-btn
                    color="blue darken-1"
                    text
                    @click="ChangeEmpStatus('Shortlisted')"
                    v-if="applc.candidateStatus == 'Interested'"
                    >Yes</v-btn
                  >

                  <v-btn
                    color="blue darken-1"
                    text
                    @click="ChangeEmpStatus('Interested')"
                    v-if="applc.candidateStatus == 'Pending'"
                    >Yes</v-btn
                  >

                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog> -->
            <v-flex xs12 pt-2>
              <v-btn
                v-if="applc.candidateStatus != 'Selected'"
                small
                style="font-family: kumbhSemibold"
                class="mr-2"
                dense
                dark
                block
                color="green"
              >
                <span v-if="applc.candidateStatus == 'Pending'">
                  Move to Candidate Pool
                </span>
              </v-btn>
            </v-flex>
            </div>
          </v-flex>
  
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog persistent v-model="dialog" width="70%">
      <v-card>
        <v-toolbar height="30px" dense dark :color="appColor">
          <v-spacer></v-spacer>
          <v-btn right icon dark @click="(doc = null), (dialog = false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-title class="text-h5 grey lighten-2"> Document </v-card-title>

        <!-- <v-card-text v-if="doc.split('.').pop() == 'pdf'">
          <iframe
            v-if="doc"
            :src="baseURL + '/' + doc"
            height="700px"
            width="900px"
            contain
          >
          </iframe>
        </v-card-text> -->
        <v-card-text v-if="doc">
          <v-img :src="mediaURL + doc"></v-img>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            small
            color="red"
            text
            @click="(dialog = false), (doc = null)"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      addEmployeeDialog: false,
      doc: null,
      showsnackbar: false,
      ServerError: false,
      msg: null,
      pages: 0,
      dialog: false,
      editdialog: false,
      editingitem: [],
      name: "",
      content: "",
      location: "",
      jobCategory: null,
      categoryList: [],
      pageCount: 1,
      appLoading: false,
      editedIndex: -1,
      currentPage: 1,
      g: false,
      perPage: 4,
      totalData: 0,
      totalRows: 0,
      dialogDelete: false,
      search: "",
      itemname: "",
      addcat: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
      category: [],
      data: [],
      coverImageFile: null,
      selectedFiles: [],
      image: null,
      coverImageArray: [],
      formDataCover: new FormData(),
      flagg: true,
      applc: null,
      positionList: null,
      //addEmployeeDialog: false,
    
        // empname: '',
        email: '',
        mobile: '',
        positionid: "",
        employeeId: '',
        dateOfJoining: ''
   
    };
  },
  mounted() {
    this.getData();
    this.getPositions();
  },

  methods: {
    getPositions() {
      this.appLoading = true;
      axios({
        url: "/getalllist/position",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          departmentId: this.department,
          projectIds: this.project,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.positionList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    ChangeEmpStatus(value) {
      axios({
        url: "/job/application/change/candidateStatus",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.id,
          candidateStatus: value,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.showsnackbar = true;
          this.msg = response.data.msg;
          this.addEmployeeDialog = false;
          this.getData();
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    DateFormatted(params) {
      // moment().format("dddd, MMMM Do YYYY, h:mm:ss a")
      // return params ? moment(params).format("DD-MMMM-Y <br> hh:mm A") : "";

      params = moment(params).subtract(5, "h").subtract(30, "m");
      return params ? moment(params).format("DD-MMMM-Y") : "";
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/job/application/get",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          id: this.$route.query.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.applc = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    addAsEmployee() {
      axios({
        url: "/accept/resume",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.$route.query.id,
          name:this.applc.name,
          email:this.applc.email,
          phonenumber:this.applc.mobile,
          positionid:this.positionid,
          employeeId:this.employeeId,
          dateofjoining:this.dateOfJoining
        },
      })
        .then((response) => {
          if(response.data.status){
            this.appLoading = false;
          this.showsnackbar = true;
          this.msg = response.data.msg;
          this.$router.go(-1);
          this.addEmployeeDialog= false;
          // this.addEmployeeDialog = false;
          }
          else{
            this.showsnackbar = true;
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
